

<div *ngIf="reportType === 'InDetail-Officer'">
  <div class="container-fluid px-4" id="print-section">

    <!-- ================= FULL HEADER (ONLY FIRST PAGE) ================= -->
    <table>
      <tr>
        <th colspan="3" class="text-start fs-5 fw-bold"style="text-align:center;font-size:18px;"
>
          हिंदुस्तान प्रकाशन संस्था
        </th>
        <th colspan="4" class="text-center fs-5 fw-bold"style="text-align:center;font-size:18px;"
>
         Book Registration Ledger Report
        </th>
        <th colspan="3" class="text-end"style="text-align:center;font-size:18px;"
>
          दिनांक {{ currentDate | date:'dd-MM-yyyy' }}
        </th>
      </tr>
      <tr>
        <th colspan="3" class="text-start fs-5 fw-bold"style="text-align:center;font-size:18px;"
>
          विवेक पुस्तक प्रकाशन
        </th>
        <th colspan="4" class="text-center fs-5 fw-bold"style="text-align:center;font-size:18px;"
>
         Representative Bookwise
        </th>
        <th colspan="3" class="text-end"style="text-align:center;font-size:18px;"
>
          From {{ startDate | date:'dd-MM-yyyy' }}
          To {{ endDate | date:'dd-MM-yyyy' }}
        </th>
      </tr>
    </table>

    <!-- ================= MAIN TABLE ================= -->
    <table 
          >

      <!-- ================= COLUMN HEADER (EVERY PAGE) ================= -->
      <thead class="print-columns">
        <tr style="background:#f1f1f1;">
          <th style="width:4%">Sr</th>
            <th style="width:16%">Representative</th> 
          <th style="width:20%">Office Rep</th>
          <!-- <th style="width:16%">Representative</th> -->
          <th class="text-end"style="width:5%">Sale<br>Copies</th>
          <th class="text-end"style="width:5%">Return<br>Copies</th>
          <th class="text-end"style="width:5%">Comp<br>Copies</th>
          <th class="text-end"style="width:7%">Total Amt</th>
          <th class="text-end"style="width:7%">Receipt Amt</th>
          <th class="text-end"style="width:7%">Credit Amt</th>
          <th class="text-end"style="width:7%">Pending Amt</th>
          <th class="text-end"style="width:6%">Rep<br>Commision<br>Amt</th>
        </tr>
      </thead>

      <tbody>

        <ng-container *ngFor="let group of groupedData">

          <!-- BOOK NAME -->
          <tr class="book-row">
            <td colspan="11"><strong>Book Name : {{ group.book_name }} </strong> </td>
          </tr>

          <!-- DATA ROWS -->
          <tr *ngFor="let row of group.records; let i = index">
            <td class="text-center">{{ i + 1 }}</td>
              <td>{{ row.crep_name }}</td> 
            <td>{{ row.office_rep_name }}</td>
            <!-- <td>{{ row.crep_name }}</td> -->
            <td class="text-end">{{ row.sale_copies }}</td>
            <td class="text-end">{{ row.return_copies }}</td>
            <td class="text-end">{{ row.complimentary_copies }}</td>
<td class="text-end">
    {{ row.calculated_total }}
  </td>
            <td class="text-end">{{ row.received_amt }}</td>
            <td class="text-end">{{ row.credit_amt  }}</td>
            <td class="text-end">{{ row.remaining_amt  }}</td>
            <td class="text-end">{{ row.rep_commission_amt  }}</td>
          </tr>

          <!-- BOOK TOTAL -->
          <tr class="book-total">
            <td colspan="3" class="text-end"style="font-weight:bold;">Book Total</td>
            <td class="text-end"style="font-weight:bold;">{{ group.saleCopies }}</td>
            <td class="text-end"style="font-weight:bold;">{{ group.returnCopies }}</td>
            <td class="text-end"style="font-weight:bold;">{{ group.compCopies }}</td>
            <td class="text-end"style="font-weight:bold;">{{ group.totalAmount  }}</td>
            <td class="text-end"style="font-weight:bold;">{{ group.totalReceived  }}</td>
            <td class="text-end"style="font-weight:bold;">{{ group.totalCredit  }}</td>
            <td class="text-end"style="font-weight:bold;">{{ group.totalRemaining  }}</td>
            <td class="text-end"style="font-weight:bold;">{{ group.totalCommission }}</td>
          </tr>

        </ng-container>

        <!-- GRAND TOTAL -->
        <tr class="grand-total">
          <td colspan="3" class="text-end"style="background:#c8753f;font-weight:bold;">Grand Total</td>
          <td class="text-end"style="background:#c8753f;font-weight:bold;">{{ grandSaleCopies }}</td>
          <td class="text-end"style="background:#c8753f;font-weight:bold;">{{ grandRetCopies }}</td>
          <td class="text-end"style="background:#c8753f;font-weight:bold;">{{ grandCompCopies }}</td>
          <td class="text-end"style="background:#c8753f;font-weight:bold;">{{ grandAmount }}</td>
          <td class="text-end"style="background:#c8753f;font-weight:bold;">{{ grandReceived  }}</td>
          <td class="text-end"style="background:#c8753f;font-weight:bold;">{{ grandCredit  }}</td>
          <td class="text-end"style="background:#c8753f;font-weight:bold;">{{ grandRemaining  }}</td>
          <td class="text-end"style="background:#c8753f;font-weight:bold;">{{ grandCommission  }}</td>
        </tr>

      </tbody>
    </table>
  </div>

  <!-- BUTTONS -->
  <div class="noPrint d-flex justify-content-end gap-3 px-4 my-3">
    <button class="btn btn-success" (click)="exportExcel('OfficeRepWise')">Export</button>
    <button class="btn btn-primary" (click)="printPage()">Print</button>
    <button class="btn btn-secondary" mat-dialog-close>Close</button>
  </div>
</div>
